import React, { ChangeEvent } from 'react';
import TextField from '@mui/material/TextField';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

export type MinuteSecondsInputProps = {
  label?: string;
  name: string;
  value: number;
  onChange: (event: ChangeEvent<HTMLInputElement>) => void;
  disabled?: boolean;
  required?: boolean;
  customClass?: string;
};

export const MinuteSecondsInput = ({
  label,
  name,
  value,
  onChange,
  disabled,
  required,
  customClass,
}: MinuteSecondsInputProps) => {
  return (
    <Box className={customClass} sx={{ width: '100%' }}>
      {label && (
        <Typography
          sx={{
            display: 'block',
            mb: 0.75,
            fontSize: '0.6875rem',
            fontWeight: 700,
            color: 'text.secondary',
            textTransform: 'uppercase',
            letterSpacing: '0.05em',
          }}
        >
          {label}
        </Typography>
      )}
      <TextField
        size="small"
        fullWidth
        name={name}
        type="number"
        value={value}
        onChange={onChange}
        disabled={disabled}
        required={required}
        inputProps={{ min: 0, max: 300 }}
        sx={{
          '& .MuiOutlinedInput-root': {
            borderRadius: '12px',
            bgcolor: 'background.paper',
            fontSize: '0.875rem',
          },
        }}
      />
    </Box>
  );
};
